import { useState, useEffect } from 'react';

const testimonials = [
  {
    name: 'Selin Kaya',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20happy%20young%20turkish%20woman%20smiling%20confidently%2C%20professional%20headshot%2C%20clean%20white%20background%2C%20natural%20beauty%2C%20friendly%20expression&width=120&height=120&seq=t001&orientation=squarish',
    treatment: 'EMS Slim',
    rating: 5,
    text: 'EMS Slim seanslarından sonra vücudum inanılmaz değişti! 8 seans sonunda kıyafetlerim artık tam oturuyor. Ayfer Hanım ve ekibi çok profesyonel, her seans özenle yapılıyor.',
  },
  {
    name: 'Melis Demir',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20confident%20middle%20aged%20turkish%20woman%20smiling%20warmly%2C%20professional%20headshot%20white%20background%2C%20natural%20glowing%20skin%20beauty&width=120&height=120&seq=t002&orientation=squarish',
    treatment: 'ARC Cilt Yenileme',
    rating: 5,
    text: 'ARC tedavisinden sonra cildim 10 yaş gençleşti! Çevremden çok yorum aldım, herkes ne yaptığımı soruyor. Kesinlikle tavsiye ediyorum, fiyat-performans açısından da mükemmel.',
  },
  {
    name: 'Zeynep Arslan',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20young%20turkish%20woman%20happy%20smile%2C%20professional%20beauty%20headshot%2C%20clean%20studio%20background%2C%20natural%20makeup%20look&width=120&height=120&seq=t003&orientation=squarish',
    treatment: 'PhiBrows Kaş',
    rating: 5,
    text: 'PhiBrows kaşlarımdan son derece memnunum! Doğal görünüyor, tam yüz şeklime uygun tasarlandı. Sabahları makyaj yapmadan da kendime güvenli hissediyorum.',
  },
  {
    name: 'Fatma Yıldız',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20mature%20turkish%20woman%20cheerful%20smile%2C%20professional%20headshot%20studio%20white%20background%2C%20elegant%20natural%20beauty&width=120&height=120&seq=t004&orientation=squarish',
    treatment: 'Lazer Epilasyon',
    rating: 5,
    text: 'Lazer epilasyon için doğru adresi buldum. 6 seans sonunda tüylerin büyük çoğunluğu tamamen gitti. Hijyenik ortam, profesyonel uygulama. Teşekkürler!',
  },
  {
    name: 'Büşra Koç',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20young%20turkish%20woman%20bright%20smile%20happy%2C%20clean%20white%20background%20headshot%2C%20natural%20fresh%20skin%20beauty&width=120&height=120&seq=t005&orientation=squarish',
    treatment: 'Cilt Bakımı',
    rating: 5,
    text: 'Düzenli cilt bakımı için Ayfer Hanım\'ı tercih ediyorum. Cildim hep bakımlı ve ışıltılı görünüyor. Ürün önerilerinde de çok yardımcı oluyorlar.',
  },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;
    const interval = setInterval(() => {
      setActive((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [paused]);

  const t = testimonials[active];

  return (
    <section id="yorumlar" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <span className="text-[#D4AF37] text-xs font-semibold uppercase tracking-[0.3em] mb-3 block">Müşteri Yorumları</span>
          <h2 className="font-serif text-3xl md:text-4xl text-[#2D2D2D] mb-4">
            Memnun
            <br />
            <em className="text-[#D4AF37]">Danışanlarımız</em>
          </h2>
          <div className="w-16 h-0.5 bg-[#D4AF37] mx-auto mt-4" />
        </div>

        <div
          className="bg-gradient-to-br from-[#FFF8F0] to-[#FFE5EC] rounded-3xl p-6 md:p-12 border border-[#D4AF37]/15"
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
        >
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 min-h-[220px]">
            {/* Quote area */}
            <div className="flex-1 order-2 md:order-1">
              <i className="ri-double-quotes-l text-5xl text-[#D4AF37]/30 block mb-4"></i>
              <p className="font-serif text-[#2D2D2D] text-lg md:text-xl italic leading-relaxed mb-6">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="flex items-center gap-4">
                <div>
                  <div className="flex items-center gap-1 mb-1">
                    {Array.from({ length: t.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-[#D4AF37] text-sm"></i>
                    ))}
                  </div>
                  <p className="font-bold text-[#2D2D2D] text-sm">{t.name}</p>
                  <div className="flex items-center gap-1.5 mt-0.5">
                    <i className="ri-check-line text-[#25D366] text-xs"></i>
                    <span className="text-[#6B6B6B] text-xs">{t.treatment} — Google Yorumu</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Photo */}
            <div className="order-1 md:order-2 flex-shrink-0">
              <div className="relative">
                <div className="w-24 h-24 md:w-36 md:h-36 rounded-full overflow-hidden border-4 border-[#D4AF37]/30">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                </div>
                <div className="absolute -bottom-1 -right-1 bg-[#D4AF37] rounded-full w-8 h-8 flex items-center justify-center">
                  <i className="ri-star-fill text-white text-xs"></i>
                </div>
              </div>
            </div>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setActive(i)}
                className={`transition-all duration-300 rounded-full cursor-pointer ${
                  i === active ? 'w-6 h-2 bg-[#D4AF37]' : 'w-2 h-2 bg-[#D4AF37]/30 hover:bg-[#D4AF37]/60'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Stats row */}
        <div className="grid grid-cols-3 gap-4 mt-8">
          {[
            { val: '500+', label: 'Mutlu Danışan' },
            { val: '4.9/5', label: 'Ortalama Puan' },
            { val: '%98', label: 'Tekrar Tercih' },
          ].map((s) => (
            <div key={s.label} className="text-center bg-[#FFF8F0] rounded-2xl p-4 border border-[#FFE5EC]">
              <p className="font-serif text-2xl md:text-3xl text-[#D4AF37] font-bold">{s.val}</p>
              <p className="text-[#6B6B6B] text-xs mt-1">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
